import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const LieuMobilite = ['UnionEuropeenne', 'HorsUnionEuropeenne'] as const

export type LieuMobilite = (typeof LieuMobilite)[number]

export const LieuMobiliteLibelle: UnionTypeLibelle<LieuMobilite> = {
  UnionEuropeenne: 'Union Européenne',
  HorsUnionEuropeenne: 'Hors Union Européenne',
} as const
